import "./styles.styl";
import React, { useState, useCallback, useEffect, useContext } from "react";
import Template from "./Payment.jsx";
import { put } from "../../util/fetch";
import { GlobalContext } from "../../globals/globalContext.jsx";

export default function PaymentController(props) {
  const [data, setData] = useState({
    type: null,
  });

  const { subscription } = useContext(GlobalContext);
  const customer = subscription.customer;

  const [hasBeenClicked, setHasBeenClicked] = useState(false);
  const [errors, setErrors] = useState({});

  const onChange = useCallback(
    (e) => {
      const { name, value } = e.target;
      // We must set the source to undefined: if we enter a
      // valid card / iban data and then switch from
      // one method to another, the button will always be enabled
      if (data?.source) {
        data.source = undefined;
      }

      setData({
        ...data,
        [name]: value,
      });
      setErrors({ ...errors, [name]: undefined, message: undefined });
      setHasBeenClicked(false);
    },
    [data, errors],
  );

  const clearErrors = useCallback(() => {
    setErrors({});
  }, []);

  const onSaveClick = useCallback(
    (paymentProvider, paymentType, setupIntentId = null, sepaData = null) => {
      const { onSuccess, onError } = props;
      setHasBeenClicked(true);

      const body = {
        payment_provider: paymentProvider,
        payment_type: paymentType,
        ...(setupIntentId && { setup_intent_id: setupIntentId }),
        ...(sepaData && sepaData),
      };
      put(customer.payment_url, { body })
        .then((response) => onSuccess && onSuccess(response))
        .catch((err) => {
          console.error(
            "Error details:", err?.data?.error_message || err?.data?.message || err
          );
          setHasBeenClicked(false);
          setErrors(err.data);
          onError && onError(err);
        });
    },
    [props, data],
  );

  return (
    <Template
      {...props}
      data={data}
      customer={customer}
      hasBeenClicked={hasBeenClicked}
      setHasBeenClicked={setHasBeenClicked}
      errors={errors}
      onChange={onChange}
      onSaveClick={onSaveClick}
      clearErrors={clearErrors}
    />
  );
}
